// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wbwZ","controls":"styles_controls__2q5jP","charLimit":"styles_charLimit__HlMS2","input":"styles_input__2Izzi","send":"styles_send__epPkY"};